import { Product } from '../types/content';
import { images } from './images';

const shirtSizes = ['S', 'M', 'L', 'XL', '2XL'];

export const products: Product[] = [
  {
    slug: 'original-trip-ink-tattoo-co-shop-shirts',
    name: 'Original Trip Ink Tattoo Co Shop Shirts',
    kind: 'apparel',
    image: images.shirt,
    categories: ['Clothing', 'Shirts'],
    description: ['The original Trip Ink Tattoo Co shop shirt. Rep the shop on the Strip and beyond.'],
    optionLabel: 'Size',
    options: shirtSizes.map((label) => ({ label, price: 25 })),
  },
  {
    slug: 'new-trip-ink-tattoo-co-shop-shirts-sweaters',
    name: 'New Trip Ink Tattoo Co Shop Shirts/Sweaters',
    kind: 'apparel',
    image: images.shirt,
    categories: ['Clothing', 'Shirts'],
    description: ['The new Trip Ink Tattoo Company Las Vegas design, available as a shirt or a sweater.'],
    optionLabel: 'Style',
    options: [
      { label: 'Shirt', price: 25 },
      { label: 'Sweater', price: 35 },
    ],
  },
  {
    slug: 'tattoo-deposit',
    name: 'Tattoo/Piercing Deposit',
    kind: 'deposit',
    categories: ['Tattoo', 'Tattoo Deposit'],
    description: [
      'Lock in your appointment with a deposit. Deposits are applied toward the final price of your tattoo or piercing.',
      'Please request your appointment first so we can confirm your artist, date, and deposit amount.',
    ],
    optionLabel: 'Amount',
    options: [25, 50, 75, 100].map((price) => ({ label: `$${price}`, price })),
  },
  {
    slug: 'shop-gift-certificates',
    name: 'Shop Gift Certificates',
    kind: 'gift',
    categories: ['Gift Certificate', 'Tattoo'],
    description: ['Give the gift of ink. Gift certificates can be used toward any tattoo, piercing, or merch at Trip Ink Tattoo Company.'],
    optionLabel: 'Amount',
    options: [10, 25, 50, 100, 150, 200, 250].map((price) => ({ label: `$${price}`, price })),
  },
  {
    slug: 'artist-custom-shirts',
    name: 'Artist Custom Shirts',
    kind: 'apparel',
    image: images.shirt,
    categories: ['Artist Custom Shirt', 'Shirts'],
    description: ['Limited shirts featuring custom designs drawn by our resident artists.'],
    optionLabel: 'Size',
    options: shirtSizes.map((label) => ({ label, price: 25 })),
  },
  {
    slug: 'trip-ink-tattoo-co-stickers',
    name: 'Trip Ink Tattoo Co Stickers',
    kind: 'sticker',
    categories: ['Stickers'],
    description: ['Trip Ink Tattoo Co logo sticker.'],
    price: 2,
    soldOut: true,
  },
  {
    slug: 'moodys-medicinals',
    name: 'Moody’s Medicinals',
    kind: 'inhouse',
    categories: ['In House Products'],
    description: ['Moody’s Medicinals products are available in-house at Trip Ink Tattoo Company. Stop by the shop to pick some up.'],
    inHouse: true,
  },
  {
    slug: 'black-flys-eye-ware',
    name: 'Black Flys Eye Ware',
    kind: 'inhouse',
    categories: ['In House Products'],
    description: ['Black Flys eyewear is available in-house at Trip Ink Tattoo Company. Stop by the shop to see the current selection.'],
    inHouse: true,
  },
  {
    slug: 'sullen-merch',
    name: 'Sullen Merch',
    kind: 'inhouse',
    categories: ['In House Products'],
    description: ['Sullen Clothing merch is available in-house at Trip Ink Tattoo Company. Stop by the shop to see what’s in stock.'],
    inHouse: true,
  },
];
